import { createSlice } from '@reduxjs/toolkit';

interface CanvasNavState {
  activePanel: string | null;
  seedanceSettingsOpen: boolean;
}

const initialState: CanvasNavState = {
  activePanel: null,
  seedanceSettingsOpen: false,
};

const canvasNavSlice = createSlice({
  name: 'canvasNav',
  initialState,
  reducers: {
    setActivePanel(state, action: { payload: string | null }) {
      state.activePanel = action.payload;
    },
    closePanel(state) {
      state.activePanel = null;
    },
    openSeedanceSettings(state) {
      state.seedanceSettingsOpen = true;
    },
    closeSeedanceSettings(state) {
      state.seedanceSettingsOpen = false;
    },
  },
});

export const { setActivePanel, closePanel, openSeedanceSettings, closeSeedanceSettings } = canvasNavSlice.actions;
export default canvasNavSlice.reducer;
